import { axiosInstance } from './axiosConfig.ts';
import { handleRequestWithAuth } from './refreshService.ts';
import {operatorHeaders,requireOperatorToken} from './pos/operatorGrant';

const API_URL = 'asistencias-sesion/';

export interface AsistenciaSesion {
  id: number;
  sesion: number;
  fecha: string;
  numero_persona: number;
  persona: number | null;
  persona_nombre: string | null;
  nombre_persona: string;
  hora_ingreso: string | null;
  hora_salida: string | null;
  observaciones_antes: string;
  observaciones_despues: string;
}

const unwrap = (data: any): AsistenciaSesion[] =>
  Array.isArray(data) ? data : (data?.results ?? []);

export const fetchAsistenciasSesion = async (sesionId: number): Promise<AsistenciaSesion[]> =>
  handleRequestWithAuth(async () => {
    const response = await axiosInstance.get(API_URL, { params: { sesion: sesionId } });
    return unwrap(response.data);
  });

export const marcarIngresoAsistencia = async (
  id: number,
  fechaHora?: string,
  timer?: {sessionId:number;operatorToken:string;motivo?:string},
): Promise<AsistenciaSesion> => handleRequestWithAuth(async () => {
  const response = await axiosInstance.post(
    `${API_URL}${id}/marcar-ingreso/`,
    {...(fechaHora ? { fecha_hora: fechaHora } : {}),...(timer?{confirmar_temporizador:true,sesion_pos:timer.sessionId,motivo:timer.motivo||''}: {})},
    timer?operatorHeaders(requireOperatorToken(timer.operatorToken)):undefined,
  );
  return response.data;
});

export const marcarSalidaAsistencia = async (
  id: number,
  fechaHora?: string,
): Promise<AsistenciaSesion> => handleRequestWithAuth(async () => {
  const response = await axiosInstance.post(
    `${API_URL}${id}/marcar-salida/`,
    fechaHora ? { fecha_hora: fechaHora } : {},
  );
  return response.data;
});

export const actualizarAsistencia = async (
  id: number,
  data: Pick<AsistenciaSesion, 'nombre_persona' | 'observaciones_antes' | 'observaciones_despues'>,
): Promise<AsistenciaSesion> => handleRequestWithAuth(async () => {
  const response = await axiosInstance.patch(`${API_URL}${id}/`, data);
  return response.data;
});

